export const DASHBOARD_BASE_PATH = '/dashboard';
export const LEGACY_DASHBOARD_BASE_PATH = '/digests';

export const DASHBOARD_ROUTE_PATTERN = /^\/(?:dashboard|digests)(?:\/|$)/;
export const DASHBOARD_NEW_ROUTE_PATTERN = /^\/(?:dashboard|digests)\/new(?:\/|$)/;
export const DASHBOARD_DELIVERY_ROUTE_PATTERN = /^\/(?:dashboard|digests)\/[^/]+\/delivery(?:\/|$)/;
export const DASHBOARD_ACTIVATION_ROUTE_PATTERN = /^\/(?:dashboard|digests)\/[^/]+\/activate(?:\/|$)/;

export function isDashboardBaseSegment(segment?: string): boolean {
    return segment === 'dashboard' || segment === 'digests';
}

export function isDashboardRoute(pathname?: string | null): boolean {
    return Boolean(pathname && DASHBOARD_ROUTE_PATTERN.test(pathname));
}

export function usesLegacyDashboardBase(pathname?: string | null): boolean {
    return Boolean(pathname && pathname.startsWith(LEGACY_DASHBOARD_BASE_PATH));
}

function normalizeSuffix(suffix = ''): string {
    if (!suffix || suffix === '/') {
        return '';
    }

    return suffix.startsWith('/') ? suffix : `/${suffix}`;
}

export function buildDashboardPath(pathname: string | null | undefined, suffix = ''): string {
    const basePath = usesLegacyDashboardBase(pathname)
        ? LEGACY_DASHBOARD_BASE_PATH
        : DASHBOARD_BASE_PATH;

    return `${basePath}${normalizeSuffix(suffix)}`;
}

export function buildCanonicalDashboardPath(suffix = ''): string {
    return `${DASHBOARD_BASE_PATH}${normalizeSuffix(suffix)}`;
}
